import { RootState } from 'store';
import IEmployeeFunctionLink from 'types/company/payroll/IEmployeeFunctionLink';
import ISelectableFunctions from 'types/company/payroll/ISelectableFunctions';

export const employeeFunctionLinksSelector = (state: RootState): IEmployeeFunctionLink[] =>
  state.employeeFunctionLinks.links;

export const selectableFunctionsSelector = (state: RootState): ISelectableFunctions =>
  state.employeeFunctionLinks.selectableFunctions;

export const linkCountsByFunctionSelector = (state: RootState): Record<number, number> =>
  state.employeeFunctionLinks.linkCountsByFunction;

export const employeeFunctionLinksLoadingSelector = (state: RootState): boolean => state.employeeFunctionLinks.loading;

export const addEmployeeFunctionLinkSuccessSelector = (state: RootState): boolean =>
  state.employeeFunctionLinks.addSuccess;
export const addEmployeeFunctionLinkErrorSelector = (state: RootState): string => state.employeeFunctionLinks.addError;

export const updateEmployeeFunctionLinkSuccessSelector = (state: RootState): boolean =>
  state.employeeFunctionLinks.updateSuccess;
export const updateEmployeeFunctionLinkErrorSelector = (state: RootState): string =>
  state.employeeFunctionLinks.updateError;

export const deleteEmployeeFunctionLinkErrorSelector = (state: RootState): string =>
  state.employeeFunctionLinks.deleteError;
